export enum AccountExchangeStatus {
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  FILLED = 'FILLED',
  DONE = 'DONE'
}
